import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = {
  isAuthenticated: false,
  user: {
    partnerAgreementId: '',
    privileges: [],
    name: '',
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
